import {
  Stack,
  Grid,
  Typography,
  TextField,
  Checkbox,
  InputAdornment,
  IconButton,
  Link,
} from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useCallback, useEffect, useState } from 'react';
import Image from 'src/components/image';
import PropTypes from 'prop-types';
import Iconify from 'src/components/iconify';
import { getSignupStatus, signup } from 'src/services/user.service';
import { usePathname, useRouter } from 'src/routes/hooks';
import { LoadingScreen } from 'src/components/loading-screen';
import TermsAndPolicy from 'src/sections/terms-and-privacy';
import { useResponsive } from 'src/hooks/use-responsive';
import Logo from 'src/components/logo';
import OrganizationDetailsView from './organization-details-view';
import PersonalDetailsView from './presonal-details-view';
import { useAuthContext } from 'src/auth/hooks';
import zIndex from '@mui/material/styles/zIndex';
import { paths } from 'src/routes/paths';

export default function SignupView({ token }) {
  // hooks
  const router = useRouter();
  const pathname = usePathname();
  const mdUp = useResponsive('up', 'md');
  const isMobile = useMediaQuery('(max-width:900px)');
  // const theme = useTheme();

  // states
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orgName, setOrgName] = useState('');
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [timeZone, setTimeZone] = useState('');
  const [currency, setCurrency] = useState('');
  const [orgSize, setOrgSize] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [designation, setDesignation] = useState('');
  const [currentStep, setCurrentStep] = useState('ORGANIZATION');
  const [formErrors, setFormErrors] = useState({});
  const [isAccepting, setIsAccepting] = useState(false);
  const [termsAndPolicyType, setTermsAndPolicyType] = useState('');
  const [isChecked, setIsChecked] = useState(true);
  const data = {
    name: name,
    password: password,
    mobile_no: phoneNo,
    phone_country_code: phoneCountryCode,
    designation: designation,
    organization_details: {
      name: orgName,
      country_code: country,
      time_zone: timeZone,
      currency_code: currency,
      state_name: state,
      organization_size: orgSize,
    },
  };

  const { login } = useAuthContext();
  // functions

  const handleOnClick = async () => {
    if (currentStep === 'ORGANIZATION') {
      const errors = {};

      if (orgName.trim() === '') {
        errors.orgName = 'Organization name is required';
      }

      if (country.trim() === '') {
        errors.country = 'Country name is required';
      }

      if (state.trim() === '') {
        errors.state = 'State name is required';
      }

      if (orgSize.trim() === '') {
        errors.orgSize = 'Organization size is required';
      }

      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
      } else {
        setFormErrors({});
        setCurrentStep('PERSONAL');
      }
    } else if (currentStep === 'PERSONAL') {
      const errors = {};
      if (name.trim() === '') {
        errors.name = 'Name is required';
      }
      if (phoneCountryCode.trim() === '') {
        errors.phoneCountryCode = 'Phone code is required';
      }
      if (phoneNo.trim() === '') {
        errors.phoneNo = 'Phone No is required';
      }
      if (designation.trim() === '') {
        errors.designation = 'Designation is required';
      }
      if (password.trim() === '') {
        errors.password = 'Password is required';
      } else {
        if (password.length < 4) {
          errors.password = 'Password must be at least 4 characters';
        }
      }
      if (!isChecked) {
        errors.isChecked = 'Please accept Terms and Conditions';
      }
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
      } else {
        setFormErrors({});

        try {
          setIsSubmitting(true);

          const response = await signup(data, token);

          if (response.success) {
            try {
              const response1 = await login?.(
                response.body.user.email,
                password,
                response.body.user.organization_id,
              );
              if (!response1.success) {
                console.error('Invalid credentials');
              } else {
                console.log('Login Successful');
              }
            } catch (error) {
              console.error('Error:', error);
              console.log('An error occurred while logging in.');
              router.push(`${pathname}/success?token=${token}`);
            }
          } else {
            throw new Error(response.message);
          }
        } catch (err) {
          console.error(err);
        } finally {
          setIsSubmitting(false);
        }
      }
    }
  };

  const handleGoBack = () => {
    setCurrentStep('ORGANIZATION');
  };

  const checkSignupInvite = useCallback(async () => {
    try {
      const response = await getSignupStatus(token);

      if (response.success) {
        const isValid = response.body.is_signed_up;

        if (isValid) {
          router.push(`/signup/success?token=${token}`);
        } else {
          setIsLoading(false);
        }
      } else if (response?.response?.status === 401) {
        router.push(`/signup/expired?token=${token}`);
      }
    } catch (err) {
      console.error(err);
    }
  }, [pathname, router, token]);

  // effects

  useEffect(() => {
    (async () => {
      await checkSignupInvite();
    })();
  }, [checkSignupInvite]);

  const renderLogo = (
    <Logo
      variant="light"
      sx={{
        position: 'absolute',
        top: 10,
        left: 12,
        zIndex: 333,
      }}
    />
  );

  const renderSection = (
    <Stack
      width="50%"
      alignItems="center"
      justifyContent="center"
      bgcolor="#000000"
    >
      <Stack position="relative" height="100%">
        <div
          style={{
            backgroundColor: 'black',
            height: '100vh',
            width: '50vw',
            display: 'flex',
            justifyContent: 'around',
            alignItems: 'center',
            flexDirection: 'column',
            padding: '2rem',
          }}
        >
          <div style={{ alignSelf: 'start' }}>
            <h1
              style={{
                fontFamily: 'vietnamPro-extra-lg, sans-serif',
                color: '#ffffff',
                fontSize: '44px',
                fontWeight: '700',
                marginBottom: '10px',
              }}
            >
              Welcome !!
            </h1>
            <p
              style={{
                fontFamily: 'vietnamPro-extra-lg, sans-serif',
                color: 'darkgray',
                fontSize: '18px',
                fontWeight: '500',
                marginTop: '0px',
              }}
            >
              Your all-in-one hiring platform to screen, interview, and hire
              candidates.
            </p>
          </div>
          <div className="image">
            <img
              className="img-fluid"
              src="https://cf-hireintel-download.hireintel.app/web-images/signup1.webp"
              style={{ height: '60vh' }}
            />
          </div>
        </div>
      </Stack>
    </Stack>
  );

  const renderContent = (
    <Stack
      flexGrow={1}
      width="50%"
      position="relative"
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: '#ffffff',
        backdropFilter: 'blur(15px)',
      }}
    >
      <Stack
        alignItems="center"
        spacing={3}
        height="30rem"
        sx={{
          bgcolor: 'transparent',
          borderRadius: '1.25rem',
          backdropFilter: 'blur(11.76998233795166px)',
          width: '100%',
        }}
        mt={2}
      >
        {currentStep && currentStep === 'ORGANIZATION' ? (
          <OrganizationDetailsView
            orgName={orgName}
            country={country}
            state={state}
            orgSize={orgSize}
            formErrors={formErrors}
            isLoading={isLoading}
            setOrgName={setOrgName}
            setCountry={setCountry}
            setState={setState}
            setTimeZone={setTimeZone}
            setCurrency={setCurrency}
            setOrgSize={setOrgSize}
            handleOnClick={handleOnClick}
          />
        ) : null}

        {currentStep && currentStep === 'PERSONAL' ? (
          <PersonalDetailsView
            name={name}
            password={password}
            phoneCountryCode={phoneCountryCode}
            phoneNo={phoneNo}
            designation={designation}
            formErrors={formErrors}
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            setName={setName}
            setPassword={setPassword}
            setPhoneCountryCode={setPhoneCountryCode}
            setPhoneNo={setPhoneNo}
            setDesignation={setDesignation}
            isSubmitting={isSubmitting}
            setIsSubmitting={setIsSubmitting}
            handleOnClick={handleOnClick}
            handleGoBack={handleGoBack}
          />
        ) : null}
      </Stack>
      <Typography
        position="absolute"
        bottom={10}
        variant="caption"
        color="#212121"
      >
        &copy; Copyright {new Date().getFullYear()}{' '}
        <Link color="#5418ef" underline="always" href="https://hireintel.app">
          Hireintel
        </Link>
        . All rights reserved.
      </Typography>
    </Stack>
  );
  return (
    <>
      {!isLoading ? (
        <>
          <Stack
            direction="row"
            sx={{
              height: '100%',
              background: '#000000',
            }}
          >
            {/* {isMobile && renderLogo} */}

            {!isMobile && renderSection}

            {renderContent}
          </Stack>
        </>
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: '100vh' }}
        >
          <LoadingScreen />
        </Stack>
      )}
    </>
  );
}

SignupView.propTypes = {
  token: PropTypes.string,
};
